import Vue from 'vue'
import VueRouter from 'vue-router'
import { getStorage, STORAGE_KEYS } from '@/utils/storage'

// 路由懒加载
const Login = () => import('@/views/Login.vue')
const MainLayout = () => import('@/layouts/MainLayout.vue')
const Home = () => import('@/views/Home.vue')
const CourseManage = () => import('@/views/CourseManage.vue')
const ArticleManage = () => import('@/views/ArticleManage.vue')
const OrderManage = () => import('@/views/OrderManage.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false // 登录页不需要token
    }
  },
  {
    path: '/',
    component: MainLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: 'course',
        name: 'CourseManage',
        component: CourseManage
      },
      {
        path: 'article',
        name: 'ArticleManage',
        component: ArticleManage
      },
      {
        path: 'order',
        name: 'OrderManage',
        component: OrderManage
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：检查token
router.beforeEach((to, from, next) => {
  // 获取token
  const token = getStorage(STORAGE_KEYS.TOKEN)
  
  // 如果访问登录页
  if (to.path === '/login') {
    // 如果已登录，跳转到首页
    if (token) {
      next('/')
      return
    }
    // 未登录，允许访问登录页
    next()
    return
  }
  
  // 访问其他页面，检查是否有token
  if (!token) {
    // 没有token，跳转到登录页
    next('/login')
    return
  }
  
  // 有token，允许访问
  next()
})

// 捕获重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

export default router

